<template>
<div>
    <employee-enrollment
        :visible="enrollmentDialogVisible"
        :action="enrollmentAction"
        :employee="employee"
        @done="enrollmentDialogVisible = false">
    </employee-enrollment>

    <el-crud :baseUrl="baseUrl" 
        v-model="resource"
        :name="'employees'"
        :actions="['view','edit','delete']"
        :config="crudConfig"
        :filters="filters"
        ref="crud">

        <!-- <template slot="additionalButtons">
            <el-button size="small" type="primary" icon="el-icon-plus" :plain="true" @click="handleSynchronize()">Sincronizar Templates</el-button>
        </template> -->

        <template slot="crudFiltersDescription">
            <div v-if="filters.functional_area_id != null && filters.functional_area_id.length">Área: <strong>{{functional_area_name}}</strong></div>
            <div v-if="filters.roster_id != null && filters.roster_id.length">Nómina: <strong>{{roster_name}}</strong></div>
            <div v-if="filters.labor_agreement_id != null && filters.labor_agreement_id.length">Acuerdo Lab.: <strong>{{labor_agreement_name}}</strong></div>
            <div v-if="filters.filter">Empleado: <strong>{{filters.filter}}</strong></div>
            <div v-if="!areFilters"><strong>Datos sin filtrar</strong></div>
        </template>

        <template slot="crudFiltersForm">
            <!-- <el-form-item label="Área" prop="functional_area_id">
                <el-select v-model="filters.functional_area_id" filterable placeholder="Seleccione">
                    <el-option label="Todas" :value="null"></el-option>
                    <el-option
                        v-for="item in functional_areas"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="Nómina" prop="roster_id">
                <el-select v-model="filters.roster_id" filterable placeholder="Seleccione">
                    <el-option label="Todas" :value="null"></el-option>
                    <el-option
                        v-for="item in rosters"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="Acuerdo Lab." prop="labor_agreement_id">
                <el-select v-model="filters.labor_agreement_id" filterable placeholder="Seleccione">
                    <el-option label="Todos" :value="null"></el-option>
                    <el-option
                        v-for="item in labor_agreements"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <!- <el-form-item label="Centro Costo" prop="cost_center_id">
                <el-select v-model="filters.cost_center_id" filterable placeholder="Seleccione">
                    <el-option label="Todos" :value="null"></el-option>
                    <el-option
                        v-for="item in cost_centers"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item> -> 
            <el-form-item label="Empleado" prop="filter">
                <el-input placeholder="Nombre, Cédula o Código" v-model="filters.filter"></el-input>
            </el-form-item> -->

            <el-row>
                <el-col :span="8">
                    <el-form-item label="Área" label-width="120px" prop="functional_area_id">
                        <el-select multiple v-model="filters.functional_area_id" filterable placeholder="Seleccione">
                            <el-option label="Todas" :value="null"></el-option>
                            <el-option
                                v-for="item in functional_areas_for_user"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="Nómina" label-width="120px" prop="roster_id">
                        <el-select multiple v-model="filters.roster_id" filterable placeholder="Seleccione">
                            <el-option label="Todas" :value="null"></el-option>
                            <el-option
                                v-for="item in rosters"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="8">
                    <el-form-item label="Empleado" label-width="120px" prop="filter">
                        <el-input placeholder="Nombre, Cédula o Código" v-model="filters.filter" clearable></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="Acuerdo Lab." label-width="120px" prop="labor_agreement_id">
                        <el-select multiple v-model="filters.labor_agreement_id" filterable placeholder="Seleccione">
                            <el-option label="Todos" :value="null"></el-option>
                            <el-option
                                v-for="item in labor_agreements"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>


        </template>

        <!-- <template slot="crudSelectedActions" slot-scope="scope"> -->
            <!-- <el-button size="small" type="primary" :plain="true" @click="handleAssignFunctionalArea(scope.checkedIds)">Asignar Área</el-button> -->
            <!-- <el-button @click.prevent="handleShowAssignmentForm(scope.checkedIds)" :disabled="checkedEmployees.length == 0" icon="el-icon-time" size="mini">Asignar Área</el-button> -->
        <!-- </template> -->
        <template slot="crudTableActions">
            <a slot="top-buttons" class="btn btn-default btn-sm" @click="downloadReport()"><i class="fa fa-download"></i> Download</a>
        </template>

        <template slot="table">
            <!-- <el-table-column
                type="selection"
                width="40">
            </el-table-column> -->
            <el-table-column
                prop="company_id_number"
                width="80"
                align="right"
                label="Código">
            </el-table-column>
            <el-table-column
                width="100"
                align="right"
                label="Cédula">
                <template slot-scope="scope">{{scope.row.id_type}} {{scope.row.id_number}}</template>
            </el-table-column>
            <el-table-column
                label="Nombre">
                <template slot-scope="scope">{{scope.row.last_name}}, {{scope.row.first_name}}</template>
            </el-table-column>
            <el-table-column
                prop="roster.description"
                width="80"
                align="center"
                label="Nómina">
            </el-table-column>
            <el-table-column
                prop="title"
                label="Cargo">
            </el-table-column>
            <el-table-column
                prop="labor_agreement.description"
                width="100"
                align="center"
                label="Ac. Laboral">
            </el-table-column>
            <el-table-column
                label="Estado"
                width="70"
                align="center">
                <template slot-scope="scope">
                    <i :class="scope.row.status === 'ACT' ? 'el-icon-success success' : 'el-icon-error danger'"></i>
                </template>
            </el-table-column>
            <el-table-column
                width="80"
                align="center"
                label="Enrolado">
                <template slot-scope="scope">
                    <el-dropdown @command="handleEnrollmentCommand">
                        <el-button :type="(scope.row.face_template_status == 'YES') ? 'success' : ((scope.row.face_template_status == 'PROCESS') ? 'warning' : 'danger')" size="mini" plain>
                            {{(scope.row.face_template_status == 'YES') ? 'SI' : ((scope.row.face_template_status == 'PROCESS') ? 'PROC' : 'NO')}}<i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item :command="{action: 'setUser', id: scope.row.id}">Enviar a dispositivo enrolador</el-dropdown-item>
                            <el-dropdown-item :command="{action: 'getUserTemplate', id: scope.row.id}">Tomar rostro de dispositivo</el-dropdown-item>
                            <el-dropdown-item :command="{action: 'syncUserTemplate', id: scope.row.id}" :disabled="scope.row.face_template_status != 'YES'">Enviar a dispositivos</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </template>
            </el-table-column>
        </template>

        <template slot="details" slot-scope="scope">
            <el-row :gutter="10">
                <el-col :sm="24" :md="12">
            <el-field
                label="Nombre">
                {{scope.item.last_name}}, {{scope.item.first_name}}
            </el-field>
                </el-col>
                <el-col :sm="24" :md="12">
            <el-field
                label="Estado">
                <i :class="scope.item.status === 'ACT' ? 'el-icon-success success' : 'el-icon-error danger'"></i>
            </el-field>
                </el-col>
            </el-row>

            <el-row :gutter="10">
                <el-col :sm="24" :md="12">
            <el-field
                label="Código">
                {{scope.item.company_id_number}}
            </el-field>
                </el-col>
                <el-col :sm="24" :md="12">
            <el-field
                label="Cédula">
                {{scope.item.id_type}} {{scope.item.id_number}}
            </el-field>
                </el-col>
            </el-row>
            <!-- <el-field
                label="Nóminas">
                <template v-if="scope.item.rosters">
                <ul v-if="scope.item.rosters !== null && scope.item.rosters.length > 0">
                    <li v-for="item in scope.item.rosters" :key="item.id + item.date_from">
                        {{item.description}} ({{item.date_from}} a {{item.date_to}})
                    </li>
                </ul>
                </template>
            </el-field> -->
            <el-row :gutter="10">
                <el-col :sm="24" :md="12">
            <el-field
                label="Acuerdo Laboral">
                <template v-if="scope.item.labor_agreement">
                    {{scope.item.labor_agreement.description}}
                </template>
            </el-field>
                </el-col>
                <el-col :sm="24" :md="12">
            <!-- <el-field
                label="Acuerdos Laborales">
                <template v-if="scope.item.labor_agreements">
                <ul v-if="scope.item.labor_agreements !== null && scope.item.labor_agreements.length > 0">
                    <li v-for="item in scope.item.labor_agreements" :key="item.id + item.date_from">
                        {{item.description}} ({{item.date_from}} a {{item.date_to}})
                    </li>
                </ul>
                </template>
            </el-field> -->
            <el-field
                label="Nómina">
                <template v-if="scope.item.roster">
                    {{scope.item.roster.description}}
                </template>
            </el-field>
                </el-col>
            </el-row>

            <el-row :gutter="10">
                <el-col :sm="24" :md="12">
            <el-field
                label="Áreas">
                <template v-if="scope.item.functional_areas">
                <ul v-if="scope.item.functional_areas !== null && scope.item.functional_areas.length > 0" class="list">
                    <li v-for="item in scope.item.functional_areas" :key="item.id + item.date_from">
                        {{item.description}} ({{item.date_from}} a {{item.date_to}})
                    </li>
                </ul>
                </template>
            </el-field>
                </el-col>
                <el-col :sm="24" :md="12">
            <el-field
                label="Salarios">
                <template v-if="scope.item.salaries">
                <ul v-if="scope.item.salaries && scope.item.salaries.length > 0" class="list">
                    <li v-for="item in scope.item.salaries" :key="item.id + item.date_from">
                        {{new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP' }).format(item.monthly_salary)}} ({{item.date_from}} a {{item.date_to}})
                    </li>
                </ul>
                </template>
            </el-field>
                </el-col>
            </el-row>

            <el-row :gutter="10">
                <el-col :sm="24" :md="12">
            <el-field
                label="Dispositivos">
                <el-tag v-for="item in scope.item.devices" :key="scope.item.id+item.id" size="mini">{{item.name}}</el-tag>
            </el-field>
                </el-col>
                <el-col :sm="24" :md="12">
            <el-field
                label="Enrolado">
                <el-dropdown @command="handleEnrollmentCommand">
                    <el-button :type="(scope.item.face_template_status == 'YES') ? 'success' : ((scope.item.face_template_status == 'PROCESS') ? 'warning' : 'danger')" size="mini" plain>
                        {{(scope.item.face_template_status == 'YES') ? 'SI' : ((scope.item.face_template_status == 'PROCESS') ? 'PROC' : 'NO')}}<i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item :command="{action: 'setUser', id: scope.item.id}">Enviar a dispositivo enrolador</el-dropdown-item>
                        <el-dropdown-item :command="{action: 'getUserTemplate', id: scope.item.id}">Tomar rostro de dispositivo</el-dropdown-item>
                        <el-dropdown-item :command="{action: 'syncUserTemplate', id: scope.item.id}" :disabled="scope.item.face_template_status != 'YES'">Enviar a dispositivos</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </el-field>
                </el-col>
            </el-row>


            <!-- <el-field
                label="Centros de Costo">
                <template v-if="scope.item.cost_centers">
                <ul v-if="scope.item.cost_centers !== null && scope.item.cost_centers.length > 0">
                    <li v-for="item in scope.item.cost_centers" :key="item.id + item.date_from">
                        {{item.description}} ({{item.date_from}} a {{item.date_to}})
                    </li>
                </ul>
                </template>
            </el-field> -->
            <el-row :gutter="10">
                <el-col :sm="24" :md="12">
            <el-field
                label="Teléono">
                {{scope.item.phone_no}}
            </el-field>
                </el-col>
                <el-col :sm="24" :md="12">
            <el-field
                label="Fecha Nacimiento">
                {{scope.item.birth_date}}
            </el-field>
                </el-col>
            </el-row>
            <el-row :gutter="10">
                <el-col :sm="24" :md="12">
            <el-field
                label="Dieta">
                {{scope.item.diet}}
            </el-field>
                </el-col>
                <el-col :sm="24" :md="12">
            <el-field
                label="Observaciones">
                {{scope.item.observations}}
            </el-field>
                </el-col>
            </el-row>

            <el-tabs v-model="activeName">
                <!-- <el-tab-pane label="Nóminas" name="rosters">
                    <employee-rosters :id="scope.item.id"></employee-rosters>
                </el-tab-pane>
                <el-tab-pane label="Áreas" name="functionalAreas">
                    <employee-functional-areas :id="scope.item.id"></employee-functional-areas>
                </el-tab-pane>
                <el-tab-pane label="Centros de Costo" name="costCenters">
                    <employee-cost-centers :id="scope.item.id"></employee-cost-centers>
                </el-tab-pane>
                <el-tab-pane label="Acuerdos Laborales" name="laborAgreements">
                    <employee-labor-agreements :id="scope.item.id"></employee-labor-agreements>
                </el-tab-pane> -->
                <el-tab-pane label="Turnos" name="shifts">
                    <employee-shifts :id="scope.item.id"></employee-shifts>
                </el-tab-pane>
                <el-tab-pane label="Horas Extra Autorizadas" name="authorizedovertime">
                    <employee-authorizedovertime :id="scope.item.id"></employee-authorizedovertime>
                </el-tab-pane>
                <el-tab-pane label="Registros" name="records">
                    <employee-records :id="scope.item.id"></employee-records>
                </el-tab-pane>
                <el-tab-pane label="Permisos" name="excuses">
                    <employee-excuses :id="scope.item.id"></employee-excuses>
                </el-tab-pane>
            </el-tabs>
        </template>


        <template slot="form" slot-scope="scope">
            <el-row>
                <el-col :span="12">
                    <el-form-item label="Apellido" label-width="140px" prop="last_name" :error="scope.errors.last_name" required :rules="[{required: true, message: 'Campo requerido'}]">
                        <el-input v-model="resource.last_name" auto-complete="off" size="mini"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="Nombre" label-width="100px" prop="first_name" :error="scope.errors.first_name" required :rules="[{required: true, message: 'Campo requerido'}]">
                        <el-input v-model="resource.first_name" auto-complete="off" size="mini"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="12">
                    <el-form-item label="Código" label-width="140px" prop="company_id_number" :error="scope.errors.company_id_number" required :rules="[{required: true, message: 'Campo requerido'}]">
                        <el-input v-model="resource.company_id_number" auto-complete="off" size="mini"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="Cédula" label-width="100px" prop="id_number" :error="scope.errors.id_number" required :rules="[{required: true, message: 'Campo requerido'}]">
                        <el-input v-model="resource.id_number" auto-complete="off" size="mini"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="12">
                    <el-form-item label="Estado" label-width="140px" prop="status" :error="scope.errors.status">
                        <el-switch
                            style="display: block"
                            v-model="resource.status"
                            active-color="#13ce66"
                            inactive-color="#ff4949"
                            active-text="Activo"
                            inactive-text="Inactivo"
                            active-value="ACT">
                        </el-switch>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="Cargo" label-width="100px" prop="title" :error="scope.errors.title">
                        <el-input v-model="resource.title" auto-complete="off" size="mini"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row  v-if="$auth.user.profile.domain !== undefined && $auth.user.profile.domain === 'riogrande'" >
                <el-form-item label="Centro Costos R." label-width="140px" prop="cost_center"  required :rules="[{required: true, message: 'Campo requerido'}]">
                    <el-select v-model="resource.cost_center" filterable placeholder="Seleccione" auto-complete="off" size="mini">
                        <el-option
                                v-for="item in cost_center_real"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-row>

            <el-row>
                <el-col :span="12">
                    <el-form-item label="Nómina" label-width="140px" prop="roster_id" :error="scope.errors.roster_id" required :rules="[{required: true, message: 'Campo requerido'}]">
                        <el-select v-model="resource.roster_id" filterable placeholder="Seleccione" auto-complete="off" size="mini">
                            <el-option
                                v-for="item in rosters"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="Acuerdo Lab." label-width="140px" prop="labor_agreement_id" :error="scope.errors.labor_agreement_id" required :rules="[{required: true, message: 'Campo requerido'}]">
                        <el-select v-model="resource.labor_agreement_id" filterable placeholder="Seleccione" auto-complete="off" size="mini">
                            <el-option
                                v-for="item in labor_agreements"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>

            </el-row>

            <el-form-item label="Áreas" label-width="140px" prop="functional_area_id" :error="scope.errors.functional_area_id">
                <div v-if="resource.edit_functional_area" style="border: 1px solid #aaa; padding: 10px 10px 10px 0">
                    <el-button icon="el-icon-close" size="mini" style="position: absolute;right: 5px;top: 5px;z-index: 99;" @click="handleCloseFunctionalAreaForm()"></el-button>
                    <el-form-item label="Área" label-width="100px" :error="scope.errors.functionalArea">
                        <el-select v-model="resource.functional_area_id" filterable placeholder="Seleccione" size="mini" style="margin-bottom: 10px;">
                            <el-option
                                v-for="item in functional_areas"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="Fechas" label-width="100px">
                        <el-col :span="11">
                            <el-date-picker
                                v-model="resource.functional_area_date_from"
                                type="date"
                                style="width: 100%;"
                                :picker-options="{firstDayOfWeek:1}"
                                placeholder="Desde" size="mini">
                            </el-date-picker>
                        </el-col>
                        <el-col class="line" :span="2" style="text-align: center;">-</el-col>
                        <el-col :span="11">
                            <el-date-picker
                                v-model="resource.functional_area_date_to"
                                type="date"
                                style="width: 100%;"
                                :picker-options="{firstDayOfWeek:1}"
                                placeholder="Hasta" size="mini">
                            </el-date-picker>
                        </el-col>
                    </el-form-item>
                </div>
                <el-button v-else icon="el-icon-plus" size="mini" @click="resource.edit_functional_area = true">Área</el-button>

                <ul v-if="resource.functional_areas !== null && resource.functional_areas.length > 0" class="list">
                    <li v-for="item in resource.functional_areas" :key="item.id + item.date_from">
                        {{item.description}} ({{item.date_from}} a {{item.date_to}})
                    </li>
                </ul>
            </el-form-item>

            <el-form-item label="Salarios" label-width="140px" prop="salary" :error="scope.errors.salary">
                <div v-if="resource.edit_salary" style="border: 1px solid #aaa; padding: 10px 10px 10px 0">
                    <el-button icon="el-icon-close" size="mini" style="position: absolute;right: 5px;top: 5px;z-index: 99;" @click="handleCloseSalaryForm()"></el-button>
                    <el-form-item label="Salario" label-width="100px" :error="scope.errors.salary">
                        <el-input v-model="resource.salary" auto-complete="off" size="mini"></el-input>
                    </el-form-item>
                    <el-form-item label="Fechas" label-width="100px">
                        <el-col :span="11">
                            <el-date-picker
                                v-model="resource.salary_date_from"
                                type="date"
                                style="width: 100%;"
                                :picker-options="{firstDayOfWeek:1}"
                                placeholder="Desde" size="mini">
                            </el-date-picker>
                        </el-col>
                        <el-col class="line" :span="2" style="text-align: center;">-</el-col>
                        <el-col :span="11">
                            <el-date-picker
                                v-model="resource.salary_date_to"
                                type="date"
                                style="width: 100%;"
                                :picker-options="{firstDayOfWeek:1}"
                                placeholder="Hasta" size="mini">
                            </el-date-picker>
                        </el-col>
                    </el-form-item>
                </div>
                <el-button v-else icon="el-icon-plus" size="mini" @click="resource.edit_salary = true">Salario</el-button>

                <ul v-if="resource.salaries && resource.salaries.length > 0" class="list">
                    <li v-for="item in resource.salaries" :key="'s' + item.date_from">
                        {{new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP' }).format(item.monthly_salary)}} ({{item.date_from}} a {{item.date_to}})
                    </li>
                </ul>
            </el-form-item>

            <el-row>
                <el-col :span="12">
                    <el-form-item label="Fecha Nacimiento" label-width="140px" prop="birth_date" :error="scope.errors.birth_date">
                        <el-date-picker
                            v-model="resource.birth_date"
                            type="date"
                            auto-complete="off" size="mini"
                            :picker-options="{firstDayOfWeek:1}"
                            placeholder="Seleccione">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="Género" label-width="140px" prop="gender" :error="scope.errors.gender">
                        <el-radio class="radio" v-model="resource.gender" label="M">Masc.</el-radio>
                        <el-radio class="radio" v-model="resource.gender" label="F">Fem.</el-radio>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="12">
                    <el-form-item label="Teléono" label-width="140px" prop="phone_no" :error="scope.errors.phone_no">
                        <el-input v-model="resource.phone_no" auto-complete="off" size="mini"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="Dieta" label-width="140px" prop="diet" :error="scope.errors.diet">
                        <el-input v-model="resource.diet" auto-complete="off" size="mini"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-form-item label="Observaciones" label-width="140px" prop="observations" :error="scope.errors.observations">
                <el-input v-model="resource.observations" auto-complete="off" size="mini" :rows="3"></el-input>
            </el-form-item>

            <el-form-item label="Dispositivos Adicionales" label-width="180px" :error="scope.errors.devices">
                <el-repetitive-field v-model="resource.devices.value" :buttonText="'Dispositivo'" :default="{device_id:null,description:null,is_admin:false}">
                    <template slot-scope="props">
                        <el-col :xs="18" :sm="10">
                            <el-form-item :prop="props.item.device_id">
                                <el-select v-model="props.item.device_id" filterable placeholder="Seleccione" size="mini">
                                    <el-option
                                        v-for="item in devices"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="5" :sm="3" :offset="1">
                            <el-form-item>
                                <el-checkbox v-model="props.item.is_admin">Administrador</el-checkbox>
                            </el-form-item>
                        </el-col>
                    </template>
                </el-repetitive-field>
            </el-form-item>
        </template>
    </el-crud>

</div>
</template>

<style>
.success {
    color: #67C23A;
    font-size: 22px;
}
.danger {
    color: #F56C6C;
    font-size: 22px;
}
.formTable {
    width: 100%;
    margin-top: 5px;
    border-collapse: collapse;
    border: 1px solid #888;
}
.formTable th, 
.formTable td {
    border: 1px solid #888;
} 
.list{
    padding-left: 14px;
}
</style>


<script>

    import { mapGetters, mapActions } from "vuex";
    import { getOptionLabel } from '../../utils/lib';
    import el_crud from '../el-crud.vue';
    import el_field from '../el-field.vue';
    import el_repetitive_field from '../el-repetitive-field.vue';
    import employee_enrollment from './employee-enrollment.vue';
    // import employee_rosters from './employee-rosters.vue';
    // import employee_functional_areas from './employee-functional-areas.vue';
    // import employee_cost_centers from './employee-cost-centers.vue';
    // import employee_labor_agreements from './employee-labor-agreements.vue';
    import employee_shifts from './employee-shifts.vue';
    import employee_excuses from './employee-excuses.vue';
    import employee_authorizedovertime from './employee-authorizedovertime.vue';
    import employee_records from './employee-records.vue';

    export default {
        data() {
            return {
                baseUrl: '/employees',
                activeName: 'records',
                crudConfig:{
                    AddItemTitle: 'Nuevo Empleado',
                    EditItemTitle: 'Editar Empleado',
                    DeleteItemConfirmMessage: 'Esto borrará permanentemente el empleado. Desea continuar?'
                },
                filters: {
                    functional_area_id: null,
                    roster_id: null,
                    labor_agreement_id: null,
                    // cost_center_id: null,
                    filter: null,
                },
                enrollmentDialogVisible: false,
                enrollmentAction: null,
                employee: null,
                // functional_areas: [],
                // labor_agreements: [],
                // rosters: [],
                // cost_centers: [],
                    // devices: [],
                cost_center_real:[
                    { label: '1003', value: '1003' },
                    { label: '1004', value: '1004' }
                ],
                downloadUrl: null,
                resource:{
                    last_name: null,
                    first_name: null,
                    company_id_number: null,
                    roster_id: null,
                    title: null,
                    cost_center:null,
                    edit_functional_area: false,
                    functional_areas: null,
                    functional_area_id: null,
                    functional_area_date_from: null,
                    functional_area_date_to: null,
                    edit_salary: false,
                    salaries: null,
                    salary: null,
                    salary_date_from: null,
                    salary_date_to: null,
                    edit_labor_agreement: false,
                    labor_agreements: null,
                    labor_agreement_id: null,
                    id_type: null,
                    id_number: null,
                    phone_no: null,
                    gender: null,
                    birth_date: null,
                    diet: null,
                    observations: null,
                    status: 'ACT',
                    devices:{
                        value: null,
                        setValue: (value) => {
                            this.resource.devices.value = [];
                            // console.log(value);
                            if (value != null) {
                                _.each(value.devices, (device) => {
                                    this.resource.devices.value.push({
                                        device_id: device.id.toString(),
                                        description: device.name,
                                        is_admin: device.is_admin == 1
                                    });
                                });
                            }
                        }
                    },
                },
    			checkedEmployees: [],
            };
        },
        components: {
            'el-crud': el_crud,
            'el-field': el_field,
            'el-repetitive-field': el_repetitive_field,
            'employee-enrollment': employee_enrollment,
            // 'employee-functional-areas': employee_functional_areas,
            // 'employee-cost-centers': employee_cost_centers,
            // 'employee-labor-agreements': employee_labor_agreements,
            // 'employee-rosters': employee_rosters,
            'employee-shifts': employee_shifts,
            'employee-excuses': employee_excuses,
            'employee-authorizedovertime': employee_authorizedovertime,
            'employee-records': employee_records,
        },
        watch: {
            $route: function(to) {
                this.setDownloadUrl();
            }
        },
        mounted() {
            this.setDownloadUrl();
            // axios.get('/api/functionalareas/optionsByUser').then((response) => {
            // axios.get('/api/functionalareas/options').then((response) => {
            //     this.functional_areas = [{label: 'Todas', value: null}];
            //     _.each(response.data, (description, id) => {
            //         this.functional_areas.push({label: description, value: id})
            //     });
            // });
            this.fetchFunctionalAreas();
            this.fetchFunctionalAreasForUser();
            this.fetchLaborAgreements();
            this.fetchRosters();
            // this.fetchCostCenters();
            this.fetchDevices();
            // axios.get('/api/laboragreements/options').then((response) => {
            //     this.labor_agreements = [{label: 'Todos', value: null}];
            //     _.each(response.data, (description, id) => {
            //         this.labor_agreements.push({label: description, value: id})
            //     });
            // });
            // axios.get('/api/rosters/options').then((response) => {
            //     this.rosters = [{label: 'Todas', value: null}];
            //     _.each(response.data, (description, id) => {
            //         this.rosters.push({label: description, value: id})
            //     });
            // });
            // axios.get('/api/costcenters/options').then((response) => {
            //     this.cost_centers = [{label: 'Todos', value: null}];
            //     _.each(response.data, (description, id) => {
            //         this.cost_centers.push({label: description, value: id})
            //     });
            // });
            // axios.get('/api/devices/options').then((response) => {
            //     _.each(response.data, (description, id) => {
            //         this.devicesOptions.push({label: description, value: id})
            //     });
            //     this.devicesOptions = _.sortBy(this.devicesOptions, 'label');
            // });
        },
        computed: {
            ...mapGetters(["functional_areas", "functional_areas_for_user", "labor_agreements", "rosters", "devices"]),
            'functional_area_name': function () { return getOptionLabel(this.functional_areas_for_user, this.filters.functional_area_id) },
            'roster_name': function () { return getOptionLabel(this.rosters, this.filters.roster_id) },
            'labor_agreement_name':function () { return getOptionLabel(this.labor_agreements, this.filters.labor_agreement_id) },
            'areFilters': function () {
                return (this.filters.functional_area_id != null && this.filters.functional_area_id.length > 0)
                        || (this.filters.roster_id != null && this.filters.roster_id.length > 0)
                        || (this.filters.labor_agreement_id != null && this.filters.labor_agreement_id.length > 0)
                        || this.filters.filter != null;
            }
        },
        methods: {
            ...mapActions(["fetchFunctionalAreas", "fetchFunctionalAreasForUser", "fetchLaborAgreements", "fetchRosters", "fetchDevices"]),
            // handleEnrollmentChange (id) {
            //     // this.$forceUpdate();
            //     console.log(id);

            //     let Idx = _.findIndex(this.$refs['crud'].$refs['dataTable'].data, {id: id});
            //     // console.log(this.$refs['crud'].$refs['dataTable'].data[Idx].has_face_template);
            //     this.employee = this.$refs['crud'].$refs['dataTable'].data[Idx];
            //     this.enrollmentDialogVisible = true;


            //     // this.$nextTick(function () {
            //     // });
            // },
            setDownloadUrl: function() {
                // console.log(this.$route);
                this.queryString = $.param(this.$route.query);
                this.downloadUrl = "/api" + this.baseUrl + "/download?" + this.queryString;
            },
            downloadReport: function() {
                window.location.href = this.downloadUrl + "&token=" + localStorage.getItem("id_token");
            },
            handleCloseFunctionalAreaForm () {
                this.resource.edit_functional_area = false;
                this.resource.functional_area_id = null;
                this.resource.functional_area_date_from = null;
                this.resource.functional_area_date_to = null;
            },
            handleCloseRosterForm () {
                this.resource.edit_roster = false;
                this.resource.roster_id = null;
                this.resource.roster_date_from = null;
                this.resource.roster_date_to = null;

            },
            // handleCloseCostCenterForm () {
            //     this.resource.edit_cost_center = false;
            //     this.resource.cost_center_id = null;
            //     this.resource.cost_center_date_from = null;
            //     this.resource.cost_center_date_to = null;
            // },
            handleCloseLaborAgreementForm () {
                this.resource.edit_labor_agreement = false;
                this.resource.labor_agreement_id = null;
                this.resource.labor_agreement_date_from = null;
                this.resource.labor_agreement_date_to = null;
            },
            handleCloseSalaryForm () {
                this.resource.edit_salary = false;
                this.resource.salary = null;
                this.resource.salary_date_from = null;
                this.resource.salary_date_to = null;
            },
            handleSynchronize (id) {
                if (id != undefined) {
                    axios.put('/api/employees/'+id+'/registrationstatus', []).then((response) => {
                        console.log(response);
                    });
                } else {
                    axios.post('/api/employees/fetchusersfacetemplates', []).then((response) => {
                        console.log(response);
                    });
                }
            },
            handleEnrollmentCommand (command) {
                // console.log(id);
                // console.log(command);
                // this.handleEnrollmentChange (command.id);

                const id = command.id;

                if (this.$refs['crud'].$refs['dataTable'] != undefined) {
                    let Idx = _.findIndex(this.$refs['crud'].$refs['dataTable'].data, {id: id});
                    // console.log(this.$refs['crud'].$refs['dataTable'].data[Idx].has_face_template);
                    this.employee = this.$refs['crud'].$refs['dataTable'].data[Idx];
                } else {
                    this.employee = this.$refs['crud'].item;
                }


                if (command.action == 'syncUserTemplate') {
                    axios.put('/api/employees/'+id+'/syncondevices', []).then((response) => {
                        console.log(response);
                    });
                } else {
                    this.enrollmentAction = command.action;
                    this.enrollmentDialogVisible = true;
                }
            },
        }
    }
</script>